<template>
  <el-form class="edit-product-quotation__base-info"
           ref="editForm"
           label-width="110px"
           size="small"
           :inline="true"
           @submit.native.prevent>
    <div class="form-card-box">
      <el-form-item label="是否多渠道"
                    class="is-min-width form-item-mb-0">
        <el-input :value="data.isSupportMultiChannel ? '是' : '否'" disabled class="edit-form__input"></el-input>
        <!--<el-radio-group
          v-model="data.isSupportMultiChannel"
          disabled
          class="edit-form__input ">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>-->
      </el-form-item>
      <template v-if="data.isSupportMultiChannel === false">
        <el-form-item label="专线api对接渠道代码"
                      label-width="170px"
                      class="is-min-width form-item-mb-0">
          <el-input :value="data.channelCode"
                    disabled
                    style="width: 600px"
                    class="edit-form__input"/>
        </el-form-item>
      </template>
    </div>
    <div class="form-card-box">
      <div class="column-title">
        分区设置
        <span style="font-size: 12px;font-weight: 400;color: #666;">
        （{{ data.isSegment ? "分段" : "全包"}}）
      </span>
      </div>
      <template v-if="data.isSegment">
        <div class="margin-bottom-sm segment-button-container">
          <el-button
            @click="changeRegionQuotationType(item,index)"
            :type="item.value === regionQuotationTypeCurrent ? 'primary' : ''"
            v-for="(item,index) in regionQuotationTypeList"
            :key="index">
            {{item.label}}</el-button>
        </div>
      </template>
      <template v-if="data.isSegment && regionQuotationTypeCurrent === 'delivery'">

        <template v-if="data.deliveryRegionHeaderList">
          <template v-for="(item,index) in data.deliveryRegionHeaderList">
            <template v-if="index === 0">
              <el-form-item label="币种">
                <el-input :value="item.currency" disabled class="edit-form__input"/>
              </el-form-item>
              <br/>
              <el-form-item label="分区类型">
                <el-select v-model="item.regionType"
                           disabled
                           class="edit-form__input"
                           placeholder="请选择">
                  <el-option
                    v-for="(item, index) in regionTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br/>
            </template>
            <div class="box-space-border"></div>
            <div class="box-card">
              <view-region-item
                :region-item-index="index"
                :region-item-item="item"
                :is-support-multi-channel="data.isSupportMultiChannel"
              />
            </div>
          </template>
        </template>
      </template>
      <template v-else>
        <city-tabs-row
          :list="data.cityRegionHeaderList"
          :default-current-value.sync="cityRegionHeaderCurrent"
        />
        <el-form-item label="是否按最小分区设置计费换算比" label-width="240px">
          <el-input :value="data.isConvertOnPartition ? '是' : '否'" disabled class="edit-form__input"/>
        </el-form-item>
        <br />
        <template v-for="(cityRegionItem,cityRegionIndex) in data.cityRegionHeaderList">
          <el-form-item label="收货仓库设置">
            <template v-for="(item,index) in cityRegionItem.cityList">
              <div style="display: inline-block;width: 300px;line-height: 40px;font-size: 16px;color:#141414;">
                {{item.cityName}}是否支持免费上门提货：
                <template v-if="item.pickUpFlag === true">是</template>
                <template v-else-if="item.pickUpFlag === false">否</template>
                <template v-else></template>
              </div>
              <div style="display: inline-block;width: 300px;line-height: 40px;font-size: 16px;color:#141414;">
                {{item.cityName}}送货到仓：{{item.receiveWarehouseName}}
              </div>
              <br/>
            </template>
          </el-form-item>
          <br/>
          <template v-if="cityRegionItem.regionHeaderList">
            <template v-for="(item,index) in cityRegionItem.regionHeaderList">
              <template v-if="cityRegionIndex===0 && index === 0">
                <el-form-item label="币种">
                  <el-input :value="item.currency" disabled class="edit-form__input"/>
                </el-form-item>
                <el-form-item label=""
                              class="is-min-width">
                  <el-checkbox
                    :value="!!cityRegionItem.isSupportMultiGoodsTypePrice ? 1 :0"
                    disabled
                    :true-label="1"
                    :false-label="0"
                  >是否支持多产品分类报价</el-checkbox>
                </el-form-item>
                <br/>
                <el-form-item label="分区类型">
                  <el-select v-model="item.regionType"
                             disabled
                             class="edit-form__input"
                             placeholder="请选择">
                    <el-option
                      v-for="(item, index) in regionTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <br/>
              </template>
              <div v-show="cityRegionHeaderCurrent === cityRegionItem._id">
                <!--<div class="box-space-border"></div>-->
                <div class="box-card">
                  <view-region-item
                    :region-item-index="index"
                    :region-item-item="item"
                    :is-support-multi-channel="data.isSupportMultiChannel"
                    :is-support-multi-goods-type-price="cityRegionItem.isSupportMultiGoodsTypePrice"
                    visible-goods-type
                    :is-show-ratio-setting="data.isConvertOnPartition"
                  />
                </div>
              </div>

            </template>
          </template>
        </template>

      </template>

      <template v-if="data.isSegment">
        <div class="column-title">头程报价</div>
      </template>
      <view-city-custom-quotation-list
        :is-support-multi-channel="data.isSupportMultiChannel"
        :list="data.cityRegionHeaderPriceTable"
        :table-header-list="tableHead"
        :type="1"
        :is-segment="data.isSegment"
        :is-show-ratio-setting="data.isConvertOnPartition"
        :showOrdinaryPrice="state === 1 && data.priceHeaderRank === 2"
      />
      <template v-if="data.isSegment">
        <div class="column-title">派送报价</div>
        <view-city-custom-quotation-list
          :is-support-multi-channel="data.isSupportMultiChannel"
          :list="data.deliveryCityRegionHeaderPriceTable"
          :table-header-list="deliverTableHead"
          :type="2"
          is-segment
          :showOrdinaryPrice="state === 1 && data.priceHeaderRank === 2"
        />
      </template>
    </div>
    <div class="form-card-box">
      <el-form-item label="是否推送更新至收藏客户"
                    class="is-min-width"
                    label-width="190px">
        <el-input :value="data.pushOpen ? '是' : '否'" disabled class="edit-form__input"/>
        <!--<el-radio-group
          :value="data.pushOpen"
          disabled
          class="edit-form__input ">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>-->
      </el-form-item>
      <el-form-item label="推送更新说明"
                    class="is-min-width"
                    label-width="180px"
                    v-if="true">
        <el-input
          :value="data.pushContent"
          disabled
          type="textarea"
          :rows="6"
          class="edit-form__input"
          style="width: 400px;"
          placeholder="请填写更新说明（必填）"/>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
  import {mapFromArrayToObject} from "@/assets/js/utils";
  import {isArray, isObject} from "my-tools-kit";
  import ViewCityCustomQuotationList
    from "@/components/QuotationManagement/components-productQuotation/viewDetails/viewCityCustomQuotationList";
  import ViewRegionItem from "@/components/QuotationManagement/components-productQuotation/viewDetails/viewRegionItem";
  import CityTabsRow from "@/components/QuotationManagement/components-productQuotation/cityTabsRow";

  let regionTypeArray = [
    {label:'邮编',value:1},
    {label:'国家',value:2},
    {label:'城市',value:3},
    {label:'仓库编码',value:4},
    { label: '邮编分区', value: 5 },
    { label: '多国家分区', value: 6 },
  ];
  let timeTypeArray = [
    {label:'工作日',value:1},
    {label:'自然日',value:2},
  ];
  export default {
    name: "viewFreightPrice",
    components: {CityTabsRow, ViewRegionItem, ViewCityCustomQuotationList},
    props:{
      data:{
        type:Object,
      },
      state: {
        type:Number,
        default: 1
      }
    },
    data(){
      return{
        // 分区类型
        regionTypeList:regionTypeArray,
        regionTypeListMapObject:mapFromArrayToObject(regionTypeArray),
        /*弹窗：设置时间*/
        timeTypeList:timeTypeArray,
        timeTypeListMapObject:mapFromArrayToObject(timeTypeArray),
        /* 分区报价类型 */
        regionQuotationTypeCurrent:"head",
        regionQuotationTypeList:[
          {label:"头程",value:"head"},
          {label:"派送",value:"delivery"},
        ],

        cityRegionHeaderCurrent:"",
      }
    },
    created(){

    },
    methods:{
      /**
       * 切换 分区报价类型
       */
      changeRegionQuotationType(item,index){
        this.regionQuotationTypeCurrent = item.value||"";
      },
      /**
       * 从 tableHeadList 中获取默认的 chargeType
       * @param tableHeadList {Array}
       */
      getTableHeadChargeType(tableHeadList = []){
        if(isArray(tableHeadList) && tableHeadList.length){
          let firstItem = tableHeadList[0] || {};
          return firstItem.chargeType || "-";
        }
        return "-";
      },
      parseTableHead(list = []){
        let chargeType = this.getTableHeadChargeType(list);
        let supportRenewal = false;//是否支持首续重
        let priceList = [];
        let headList = [];
        // if(chargeType.toUpperCase() === "BOX") chargeType = "箱";
        // else if(chargeType.toUpperCase() === "PK") chargeType = "车";
        if(isArray(list) && list.length){
          let first = list[0]||{};
          supportRenewal = !!first.supportRenewal;
          if(isArray(first.priceDetailList) && first.priceDetailList.length){
            let firstPriceDetails = first.priceDetailList[0] || {};
            priceList = firstPriceDetails.priceList || [];
          }
        }
        if(isArray(priceList)) headList = priceList.map(res=>{
          return {
            start:res.sectionStartNum,
            end:res.sectionEndNum,
            chargeType,
            supportRenewal,
          }
        });
        return headList;
      },
    },
    computed:{
      tableHead(){
        return this.parseTableHead(this.data.regionHeaderList);

      },
      deliverTableHead(){
        return this.parseTableHead(this.data.deliveryRegionHeaderList);
      },
    },
    watch:{
      data:{
        immediate:true,
        handler(newVal){
          let list = newVal.cityRegionHeaderList||[];
          let first = list[0];
          if(first) this.cityRegionHeaderCurrent = first._id;
          else this.cityRegionHeaderCurrent = "";
        }
      },
    }
  }
</script>

<style scoped lang="scss">
.column-title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin: 0 auto 15px;
}

.FormWrap {
  position: relative;
  .index {
    position: absolute;
    left: -30px;
    top: 10px;
  }
}
.box-space-border{
  border-top: 1px dashed #ddd;
  margin-bottom: 10px;
}
.box-card {
  padding: 20px;
  background: #F9F9F9;
  border-radius: 12px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewFreightPrice.vue